import type { DeploymentStepResource } from "@octopusdeploy/octopus-server-client";
import type { NamedStepWithAction } from "~/areas/tasks/components/Task/NamedStepWithAction";
export function retrieveStepsWithArgoCDActions(deploymentStepResources: DeploymentStepResource[]): NamedStepWithAction[] {
    const argoCDActionTypes = ["Octopus.ArgoCDUpdateImageTags", "Octopus.ArgoCDUpdateManifests"];
    return deploymentStepResources.reduce<NamedStepWithAction[]>((steps, step, stepIndex) => {
        for (let actionIdx = 0; actionIdx < step.Actions.length; actionIdx++) {
            const action = step.Actions[actionIdx];
            if (!action.IsDisabled && argoCDActionTypes.includes(action.ActionType)) {
                let stepName: string = "";
                if (step.Actions.length > 1) {
                    stepName = `Step ${stepIndex + 1}.${actionIdx + 1}: ${action.Name}`;
                }
                else {
                    stepName = `Step ${stepIndex + 1}: ${step.Name}`;
                }
                steps.push({
                    stepName,
                    actionId: action.Id,
                });
            }
        }
        return steps;
    }, []);
}
